import { AbstractContentState, useCmsContent } from '@cp-shared-10/frontend-integration';
import { LandingPageMarketingCard } from 'common';
import { fetchLandingPageMarketingCards } from './LandingPageMarketingCardsSlice';
import { LandingPageMarketingCardsContentSelector } from './LandingPageMarketingCardsContentSelector';

export function useLandingPageMarketingCards(): AbstractContentState<LandingPageMarketingCard[]> {
    return useCmsContent(fetchLandingPageMarketingCards, LandingPageMarketingCardsContentSelector);
}
